import { render, staticRenderFns } from "./ManualSearch.vue?vue&type=template&id=04a94fa0&scoped=true&"
import script from "./ManualSearch.vue?vue&type=script&lang=js&"
export * from "./ManualSearch.vue?vue&type=script&lang=js&"
import style0 from "./ManualSearch.vue?vue&type=style&index=0&id=04a94fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a94fa0",
  null
  
)

export default component.exports